export default class BaseApi {
  constructor(endpoint) {
    this.endpoint = endpoint
  }

  static parseResponse(response) {
    if ([201, 202, 204].indexOf(response.status) !== -1) {
      return { json: null, response }
    }

    let promise

    const contentType = response.headers.get('Content-Type')
    if (contentType && contentType.indexOf('json') !== -1) {
      promise = response.json()
        .then(json => ({ json, response }))
    } else {
      promise = response.text()
        .then(text => ({ text, response }))
    }

    return promise.catch(error => ({
      error,
      response,
    }))
  }

  static rejectRequest(okCheck) {
    return function rejectRequest(result) {
      if (!okCheck(result.response) || result.error) {
        const err = Error(
          result.error ||
          (result.response && result.response.statusText) ||
          'API Call Failure',
        )
        err.response = result.response
        err.json = result.json

        throw err
      }

      return result
    }
  }

  static returnBody(result) {
    return result.json || result.text || null
  }

  innerRequest(authToken, method, path, body, additionalHeaders = {}) {
    if (body && typeof body !== 'string') {
      body = JSON.stringify(body)
    }

    const options = {
      body,
      headers: this.constructor.requestHeaders(authToken, additionalHeaders),
      method,
    }

    return fetch(`${this.endpoint}${path}`, options)
      .then(this.constructor.parseResponse)
  }

  request(authToken, method, path, body, additionalHeaders = {}, okCheck = r => r.ok) {
    return this.innerRequest(authToken, method, path, body, additionalHeaders)
      .then(this.constructor.rejectRequest(okCheck))
      .then(this.constructor.returnBody)
  }

  static requestHeaders(authToken, additionalHeaders) {
    return {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...additionalHeaders,
    }
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/api/base.js